module.exports = __webpack_public_path__ + "img/IT0000105944149.578626b3.png";